var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, Prop, html, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Tab.style';
/**
 * Single Tab, to be used within tabs (between the <davinci-tabs> tag).
 */

export let Tab = (_dec = Component({
  tag: 'davinci-tab',
  style
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = (_temp = class Tab extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "index", _descriptor, this);

    _initializerDefineProperty(this, "selected", _descriptor2, this);

    _initializerDefineProperty(this, "title", _descriptor3, this);

    _initializerDefineProperty(this, "icon", _descriptor4, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor5, this);
  }

  render() {
    return html`<slot></slot>`;
  }

  renderIcon() {
    let icon = html`${nothing}`;

    if (!!this.iconSrc) {
      icon = html`<davinci-icon-ref class="custom-icon" src=${this.iconSrc}></davinci-icon-ref>`;
    }

    if (!!this.icon) {
      icon = html`<davinci-icon class="custom-icon" icon=${this.icon}></davinci-icon>`;
    }

    return icon;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "index", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selected", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
})), _class2)) || _class);
//# sourceMappingURL=Tab.js.map